export enum LoadableStatus {
  Loading,
  Loaded,
  Empty,
  Failure,
}
